export const config = {
  title: "Campbell's Cleaning Crew | Affordable Cleaning Services in Kankakee County, IL",
  meta: {
    description:
      "Campbell's Cleaning Crew offers top-quality, affordable cleaning services in Kankakee County, IL, ensuring your home or business remains spotless and welcoming.",
    keywords: [
      'Cleaning Services Kankakee County',
      'Home Cleaning',
      'Residential Cleaning',
      'Campbell\'s Cleaning Crew',
      'Maid Services',
      'Deep Cleaning',
      'Housekeeping Kankakee County',
      'Illinois Cleaning Services',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Campbell's Cleaning Crew",
    canonicalUrl: 'https://www.campbellscleaningcrew.com/',
  },
  sections: {
    header: {
      businessName: "Campbell's Cleaning Crew",
    },
    sectionB: {
      heroTitle: "Campbell's Cleaning Crew",
      heroSubtitle: 'Affordable Cleaning Services for a Healthier Lifestyle',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '+1-815-295-3485',
      phoneLabel: '(815) 295-3485',
      heroBackgroundImage:
      "https://media.istockphoto.com/id/1794629243/photo/woman-maid-cleaning-and-wiping-the-table-with-microfiber-cloth-in-office.jpg?s=612x612&w=0&k=20&c=yE1r3oUanfjS6UVqm1H2A8jQVLss288VVEe2d-3tY04=",
      cardData: [
        {
          title: 'Mission',
          description:
            'At Campbell\'s Cleaning Crew, our mission is to provide top-quality, affordable cleaning services to help you maintain a healthier lifestyle.',
        },
        {
          title: 'Vision',
          description:
            'Our vision is to be the preferred choice for residential and commercial cleaning services in Kankakee County, IL, known for our professionalism and attention to detail.',
        },
        {
          title: 'Why Choose Us',
          description:
            'We offer personalized cleaning solutions tailored to your needs, ensuring a spotless and comfortable environment.',
        },
      ],
      description:
        "Campbell's Cleaning Crew specializes in residential and commercial cleaning, offering deep cleaning, move-in/move-out services, and regular maintenance to keep your space pristine.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover the comprehensive cleaning services we offer to maintain the cleanliness and comfort of your home or business.",
      cards: [
        {
          title: 'Residential Cleaning',
          description:
            'Tailored cleaning services to keep your home spotless and comfortable.',
          imageSrc:
            'https://files.cdn-files-a.com/uploads/10378608/2000_67b96c04ba342.jpg',
          imageAlt: 'Residential Cleaning Services',
        },
        {
          title: 'Commercial Cleaning',
          description:
            'Comprehensive cleaning solutions to prepare your property for new occupants or to leave it spotless upon departure.',
          imageSrc:
            'https://files.cdn-files-a.com/uploads/10378608/2000_67bd316aa7492.jpg',
          imageAlt: 'Commercial Cleaning Services',
        },
        {
          title: 'Deep Cleaning',
          description:
            'Thorough cleaning services targeting every nook and cranny for a pristine environment.',
          imageSrc:
            'https://files.cdn-files-a.com/uploads/10378608/2000_67b96cac8cbb3.jpg',
          imageAlt: 'Deep Cleaning Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Office and Commercial Cleaning',
        'Organization & Decluttering',
        'Post-Construction Cleaning',
        'Carpet Cleaning',
        'Window Cleaning',
        'Customized Cleaning Plans'
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://files.cdn-files-a.com/uploads/10378608/2000_67b96c715761f.jpg',
        alt: "Campbell's Cleaning Crew Team",
      },
      aboutText: [
        "Campbell's Cleaning Crew is dedicated to delivering top-quality, affordable cleaning services to help you maintain a healthier lifestyle. Our team of trusted, experienced professionals ensures your home or business remains healthy and welcoming.",
        "With a focus on reliability and quality, we tailor our services to meet your specific needs, allowing you to concentrate on what truly matters.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Campbell's Cleaning Crew",
      businessName: "Campbell's Cleaning Crew",
      contact: {
        phone: '+1-815-295-3485',
        phoneLabel: '(815) 295-3485',
        email: 'campbells.cleancrew@gmail.com',
        website: 'https://www.campbellscleaningcrew.com/',
        address: 'Kankakee County, IL, USA',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Kankakee County, IL, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3143.123456789012!2d-87.8641234!3d41.1412345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880c1234567890ab%3A0x1234567890abcdef!2sKankakee%20County%2C%20IL!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
